import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100%;
`;

export const ContentCard = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #edf1f5;
  border-radius: 10px;
  padding: 0;
  box-sizing: border-box;
  min-height: 620px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  padding: 14px 20px;
`;

export const CardTitle = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: #2e2c34;
  line-height: 1.2;
`;

export const TableWrapper = styled.div`
  width: 100%;
  padding: 0 0 18px 0;
  box-sizing: border-box;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 0.8fr 0.9fr 1fr 1fr 0.5fr;
  column-gap: 18px;
  background: #f1f5f8;
  padding: 12px 22px;
  margin-top: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderText = styled.div`
  color: #407bff;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
`;

export const TableBody = styled.div`
  width: 100%;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 0.8fr 0.9fr 1fr 1fr 0.5fr;
  column-gap: 18px;
  align-items: center;
  padding: 18px 22px;
  width: 100%;
  box-sizing: border-box;
`;

export const CellText = styled.div`
  color: #4b5563;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
`;

export const InvoiceLink = styled.div`
  color: #407bff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 65px;
  padding: 3px 10px 3px 18px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  position: relative;
  background: ${(p) => (p.variant === "active" ? "#dff0dd" : "#fde8e3")};
  color: ${(p) => (p.variant === "active" ? "#2f9e44" : "#ff7f66")};

  &::before {
    content: "";
    position: absolute;
    left: 8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(p) => (p.variant === "active" ? "#2f9e44" : "#ff7f66")};
  }
`;

export const ActionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const ActionButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  color: #2e2c34;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 30px;
  right: -8px;
  min-width: 110px;
  background: #ffffff;
  border: 1px solid #d9dee7;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(16, 24, 40, 0.08);
  z-index: 100;
  overflow: hidden;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
  background: #ffffff;

  &:hover {
    background: #f8fafc;
  }
`;

export const EmptyText = styled.div`
  text-align: center;
  padding: 40px 0 20px 0;
  color: #98a2b3;
  font-size: 15px;
  font-weight: 500;
`;
